import {
  Button,
  CircularProgress,
  Grid,
  Stack,
  Typography,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import SimpleAccordion from "src/qubCommon/Accordions/SimpleAccordion";
import { House, Sync, Visibility } from "@mui/icons-material";
import FathersTable from "./FathersTable";
import CustomSimpleAccordion from "qubCommon/Accordions/CustomSimpleAccordion";
import { useEffect, useState } from "react";
import { format } from "date-fns";
import ReviewSection from "qubCommon/ReviewSection";
import { validateHusbands } from "apis/controllers/externalData";
import { useParams } from "react-router-dom";
import { createMarkup } from "util/createMarkup";
import { useFormContext } from "react-hook-form";

const Fathers = ({ husbands, review, settings }) => {
  const [loading, setLoading] = useState(false);
  const [checkInfo, setCheckInfo] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const { id } = useParams();
  const form = useFormContext();

  const handleCheck = async () => {
    setLoading(true);
    try {
      const result = await validateHusbands(id);
      setCheckInfo(result?.data);
      setOpenModal(true);
    } catch (err) {
      console.error("Error during check:", err);
    } finally {
      setLoading(false);
    }
  };

  const AccordionTitle = () => (
    <Stack direction="row" gap={1}>
      <House color="primary" fontSize="small" sx={{ marginLeft: "2px" }} />
      <Typography color="primary" sx={{ fontWeight: 1000 }}>
        ΓΟΝΕΙΣ Ή ΠΡΟΣΩΠΑ ΜΕ ΣΧΕΣΗ ΑΣΦΑΛΙΣΗΣ Ή ΕΠΙΜΕΛΕΙΑΣ ΜΕ ΤΑ ΤΈΚΝΑ
      </Typography>
      <Typography color="primary">
        ({form?.watch("husbandsHelp")?.length})
      </Typography>
    </Stack>
  );

  const renderModalContent = () => {
    if (!checkInfo) return null;

    return <div dangerouslySetInnerHTML={createMarkup(checkInfo?.message)} />;
  };

  useEffect(() => {
    if (review?.wsResponse?.message)
      setCheckInfo({
        message: review?.wsResponse?.message,
        timestamp: review?.wsResponse?.timestamp,
        clipboardText: review?.wsResponse?.clipboardText,
      });
  }, [review]);

  return (
    <CustomSimpleAccordion
      title={<AccordionTitle />}
      content={
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FathersTable
              husbands={husbands}
              results={checkInfo?.results}
              canEdit={settings?.canEdit}
              canPartiallyEdit={settings?.canPartiallyEdit}
              canAdd={settings?.canAdd}
              canDelete={settings?.canDelete}
            />
          </Grid>
          <Grid item xs={12}>
            <ReviewSection
              canApprove={settings?.canApprove}
              canViewReview={settings?.canViewReview}
              canViewWSResult={settings?.canViewWSResult}
              fieldPrefix="reviews.husbands"
              extra={
                husbands?.length > 0 ? (
                  <Grid item xs={12} style={{ display: "flex" }} gap={1}>
                    {settings?.canApprove && (
                      <Button
                        onClick={handleCheck}
                        variant="contained"
                        startIcon={
                          loading ? (
                            <CircularProgress size={24} color="inherit" />
                          ) : (
                            <Sync />
                          )
                        }
                        disabled={loading}
                      >
                        WebService - Έλεγχος
                      </Button>
                    )}

                    {checkInfo &&
                      (settings?.canViewWSResult || settings?.canApprove) && (
                        <div style={{ marginLeft: "auto", display: "flex" }}>
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            mt={1}
                            mr={1}
                          >
                            Τελευταίος Έλεγχος: {checkInfo.timestamp}
                          </Typography>
                          <Button
                            variant="outlined"
                            startIcon={<Visibility />}
                            onClick={() => setOpenModal(true)}
                          >
                            Αποτελέσματα Ελέγχου
                          </Button>
                        </div>
                      )}
                  </Grid>
                ) : null
              }
            />
          </Grid>

          {/* Modal */}
          <Dialog
            open={openModal}
            onClose={() => setOpenModal(false)}
            maxWidth="md"
            fullWidth
          >
            <DialogTitle>Αποτελέσματα Ελέγχου Έτερων Γονέων</DialogTitle>
            <DialogContent>{renderModalContent()}</DialogContent>
            <DialogActions>
              <Button
                variant="contained"
                color="error"
                onClick={() => setOpenModal(false)}
              >
                Κλείσιμο
              </Button>
              {settings?.canApprove && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    form.setValue(
                      "reviews.husbands.comments",
                      checkInfo?.clipboardText
                    );
                    setOpenModal(false);
                  }}
                >
                  Ενημέρωση Παρατηρήσεων
                </Button>
              )}
            </DialogActions>
          </Dialog>
        </Grid>
      }
    />
  );
};

export default Fathers;
